import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { FaTrophy, FaBriefcase, FaUserGraduate } from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PrideExcellence = ({ openModal }) => {
    const [activeTab, setActiveTab] = useState("placements");
    const [progress, setProgress] = useState(0);

    const sliderRef = useRef(null);

    const settings = {
        infinite: true,
        speed: 600,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2500,
        beforeChange: (current, next) => {
            setProgress((next / 10) * 100);
        },
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 4 } },
            { breakpoint: 992, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 576, settings: { slidesToShow: 2 } },
        ],
    };

    // const placementImages = [
    //     "riyaz-alum.png",
    //     "rohit-ranjan.png",
    //     "ojesvi-kushwah.png",
    //     "kanishk-sharma.png",
    //     "vikash-gupta.png",
    //     "ayush-pandy.png",
    //     "uma-mishra.png",
    //     "shivpratap-chouhan.png",
    //     "rishab-ranjan.png",
    //     "college-student.png",
    // ];
    const placementImages = [
        "ayush.webp",
        "college_student.webp",
        "kanishk.webp",
        "ojesvi-kushwah.webp",
        "rishab.webp",
        "riyaz.webp",
        "rohit-ranjan.webp",
        "shivpratap.webp",
        "uma.webp",
        "vikash.webp",
    ];

    const topperImages = [
        "bazila-4th-merit.webp",
        "harveer-5th-merit.webp",
        "shashank-5th-merit.webp",
        "akshita-2nd-merit.webp",
        "divisha-3rd-merit.webp",
        "diyanshi-1st-merit.webp",
        "himanshu-3rd-merit.webp",
        "pankaj-1st-merit.webp",
        "prince-3rd-merit.webp",
        "sidhant-1st-merit.webp",
        "snehil-4th-merit.webp",
        "vinay-1st-merit.webp",
    ];
    const alumniData = [
        {
            image: "anshul.webp",
            name: "Anshul Rohilla",
            desc: "Engineering Lead Believue, Washington",
            link: "https://www.linkedin.com/in/anshulrohilla/"
        },
        {
            image: "akshay-lodha.webp",
            name: "Akshay Lodha",
            desc: "Manager New Jersey",
            link: "https://www.linkedin.com/in/akshaylodha/"
        },
        {
            image: "hema.webp",
            name: "Hema Achtani",
            desc: "SAP Consultant, Singapore",
            link: "https://www.linkedin.com/in/hema-achtani-3b2b8b10/"
        },
        {
            image: "ojesvi.webp",
            name: "Ojesvi Kushwah",
            desc: "Global Cloud Infrastructure Architect Germany",
            link: "https://www.linkedin.com/in/ojesvi-k-475a88147/"
        },
        {
            image: "pratik.webp",
            name: "Pratik Pandya",
            desc: "Consultant, Singapore",
            link: "https://www.linkedin.com/in/pratikpandyasg/"
        },
        {
            image: "riyaz-alumni.webp",
            name: "Riyaz Ul Haque",
            desc: "Sr Software Engineer USA",
            link: "https://www.linkedin.com/in/riyazulhaque/"
        },
        {
            image: "rohit.webp",
            name: "Rohit Ranjan Sharma",
            desc: "Security Engineer, USA",
            link: "https://www.linkedin.com/in/rohitranjansharma/"
        },
        {
            image: "varnika.webp",
            name: "Varnika Bhasin",
            desc: "Service Desk Officer, Hobart, Tasmania",
            link: "https://www.linkedin.com/in/varnika-bhasin-19429a190/"
        },
        {
            image: "roshita.webp",
            name: "Roshita Jaiswal",
            desc: "Senior Consultant, Canada",
            link: "https://www.linkedin.com/in/roshita-jaiswal/"
        },
        {
            image: "dushyantraj.webp",
            name: "Dushyant Raj",
            desc: "DevOps Engineer",
            link: "https://www.linkedin.com/in/dushyantraj-sharma-85310a171/"
        },
    ];

    const renderSlider = (data, type = "image") => (
        <Slider {...settings} ref={sliderRef} className="sliderTraik">
            {data.map((item, i) => (
                <div key={i} style={{ padding: "0 10px" }}>
                    {type === "alumni" ? (
                        <div className="alumni_cart border mx-2">
                            <div className="alumni_img px-2">
                                <img
                                    className="img-fluid w-100"
                                    src={`/images/${item.image}`}
                                    alt={item.name}
                                />
                            </div>
                            <div className="alumni_content">
                                <p className="alumni_name mb-0">{item.name}</p>
                                <p className="alumni_decs mb-0">{item.desc}</p>
                                {/* <a
                                    className="text-decoration-none"
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="alumni_socil d-flex justify-content-between pt-lg-5 pt-4">
                                        <span>View portfolio</span>
                                        <span><IoLogoLinkedin /></span>
                                    </div>
                                </a> */}
                            </div>
                        </div>
                    ) : (
                        <img className="px-lg-3 px-2"
                            src={`/images/${item}`}
                            alt="student"
                            style={{ width: "100%", borderRadius: "12px" }}
                        />
                    )}
                </div>
            ))}
        </Slider>
    );

    return (
        <section
            style={{
                background: "#fdf3f3",
                padding: "30px 0",
                position: "relative",

            }}
        >
            {/* Dotted Background */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "radial-gradient(rgba(180,1,3,0.15) 1px, transparent 1px)",
                    backgroundSize: "22px 22px",
                    opacity: 0.6,
                }}
            />

            <div className=" text-center" style={{ position: "relative", zIndex: 2 }}>

                {/* Heading */}
                <h2 className="sub_heading text-center mb-0" style={{ fontWeight: "700" }}>
                    Our Pride & <span style={{
                        background: "linear-gradient(90deg, #4E0001 , #B40103 )",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                    }}>Excellence</span>
                </h2>

                <p style={{
                    background: "linear-gradient(90deg, #B40103, #4E0001)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                }} className="mb-0 text-center">
                    Celebrating alumni success, record-breaking placements, and academic toppers — All in one place*
                </p>

                {/* Tabs */}
                <div className="d-flex  justify-content-sm-center justify-content-start pb-2 px-2 overflow-x-scroll overflow-x-sm-auto btn-main"
                    style={{
                        marginTop: "30px",
                        display: "flex",
                        justifyContent: "center",
                        gap: "12px",
                    }}
                >
                    {[
                        { key: "toppers", icon: <FaTrophy />, label: "Toppers" },
                        { key: "placements", icon: <FaBriefcase />, label: "Placements" },
                        { key: "alumni", icon: <FaUserGraduate />, label: "Alumni" },
                    ].map((tab) => (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            style={{
                                background: activeTab === tab.key ? "#e11b22" : "#fff",
                                color: activeTab === tab.key ? "#fff" : "#e11b22",
                                border: "1px solid #e11b22",
                                padding: "8px 20px",
                                borderRadius: "25px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontWeight: "500",
                            }}
                        >
                            {tab.icon} {tab.label}
                        </button>
                    ))}
                </div>

                {/* Sliders */}
                <div style={{ marginTop: "50px" }}>
                    {activeTab === "placements" && renderSlider(placementImages)}
                    {activeTab === "toppers" && renderSlider(topperImages)}
                    {activeTab === "alumni" && renderSlider(alumniData, "alumni")}
                </div>

                {/* Progress Bar */}
                <div
                    style={{
                        width: "200px",
                        height: "5px",
                        background: "#ffffff",
                        margin: "35px auto 0",
                        borderRadius: "10px",
                        overflow: "hidden",
                        border: "1px solid #f3c6c6",
                    }}
                >
                    <div
                        style={{
                            width: `${progress}%`,
                            height: "100%",
                            background: "#f3c6c6",
                            transition: "0.4s",
                        }}
                    />
                </div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-7 text-md-end text-center">
                            {/* Apply Button */}
                            <div style={{ marginTop: "30px" }}>
                                <button onClick={() => openModal("Apply Now")}
                                    className="applyBtn"
                                >
                                    Apply Now <MdArrowOutward />
                                </button>
                            </div>
                        </div>
                        <div className="col-md-5">
                            {/* Bottom Paragraph */}
                            <div className="text-md-end text-center"
                                style={{
                                    marginTop: "20px",
                                    // textAlign: "right",
                                    fontSize: "12px",
                                    color: "#555",
                                }}
                            >
                                *This data is based on past Alumni
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </section>
    );
};

export default PrideExcellence;